import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import { history } from '@store/history';

const TABLE_DATA: any = {
	SATs: {
		title: ['KS1', 'KS2', 'KS3', 'KS4'],
		English: {
			kp: [
				['Vowel Sounds', 'Information Texts', 'Types of Sentences'],
				['Vowel Sounds', 'Information Texts', 'Types of Sentences'],
				['Vowel Sounds', 'Information Texts', 'Types of Sentences'],
				['Vowel Sounds', 'Information Texts', 'Types of Sentences'],
			],
			lc: [
				['Master spelling skills', 'Master basic language learning skills', 'Strengthen basic grammar'],
				['Master spelling skills', 'Master basic language learning skills', 'Strengthen basic grammar'],
				['Master spelling skills', 'Master basic language learning skills', 'Strengthen basic grammar'],
				['Master spelling skills', 'Master basic language learning skills', 'Strengthen basic grammar'],
			],
		},
		Maths: {
			kp: [
				[
					'Number and Place Value',
					'Addition and subtraction',
					'Multiplying and division',
					'Fractions',
					'Measurement',
					'Geometry',
					'Statistics',
				],
				['Number and Place Value', 'Calculations', 'Fractions and decimals', 'Measurement', 'Geometry', 'Statistics'],
				['Numbers', 'Algebra', 'graphs', 'ratio, proportion and rate of change', 'Geometry and measure', 'Probability and Statistics'],
				['Number', 'Ratio and proportion', 'Geometry', 'Algebra', 'Statistics', 'Probability'],
			],
			lc: [
				[
					'Recognize numbers within 100',
					'Master number and the four fundamental operations of arithmetic',
					'A preliminary understanding of multiplication and division',
				],
				['Master the calculation method of multiplication and division', 'Master the problem-solving skills of reasoning problems'],
				[
					'Master basic calculation methods',
					'Master geometry and its measurement method',
					'Be able to solve mathematical problems in real life',
				],
				[
					'Master basic calculation skills',
					'Be able to reason and explain mathematically',
					'Be able to apply mathematical knowledge in real life',
				],
			],
		},
	},
	GCSE: {
		title: ['Grade 1-3', 'Grade 4-6', 'Grade 7-9'],
		English: {
			kp: [
				[
					'Explorations in Creative Reading and Writing',
					`Writers' Viewpoints and Perspectives`,
					'Shakespeare and the 19th-century novel',
					'Modern texts and poetry',
				],
				[
					'Explorations in Creative Reading and Writing',
					`Writers' Viewpoints and Perspectives`,
					'Shakespeare and the 19th-century novel',
					'Modern texts and poetry',
				],
				[
					'Explorations in Creative Reading and Writing',
					`Writers' Viewpoints and Perspectives`,
					'Shakespeare and the 19th-century novel',
					'Modern texts and poetry',
				],
			],
			lc: [
				[
					'Consolidate the basic and strengthen grammar',
					'Improve basic language organization ability and strengthen writing skills',
					'Master the basic skills of critical reading',
				],
				[
					'Master the basic reading methods of Shakespeare and the 19th century novel',
					'Master the ability of structural analysis in writing',
					'Enhance the ability of literary comparative analysis',
				],
				[
					'Higher level of capacity, advance towards A and A * grades',
					'Skillfully use the reading skills of Shakespeare and the 19th century novel',
					'Skillfully use the writing skills of argumentation',
				],
			],
		},
		Maths: {
			kp: [
				['Number', 'Ratio and proportion', 'Geometry', 'Algebra', 'Statistics', 'Probability'],
				['Number', 'Ratio and proportion', 'Geometry', 'Algebra', 'Statistics', 'Probability'],
				['Number', 'Ratio and proportion', 'Geometry', 'Algebra', 'Statistics', 'Probability'],
			],
			lc: [
				[
					'Consolidate the basic, master basic calculation skills',
					'Be able to reason and explain  mathematically',
					'Be able to apply mathematical knowledge in real life',
				],
				[
					'Capacity promotion',
					'Be able to skillfully use and apply mathematical knowledge',
					'Be able to use mathematical methods to solve practical problems in combination with specific situations',
				],
				[
					'Higher level of capacity',
					'Improve mechanical mathematics ability',
					'Master problem analysis skills',
					'Can skillfully use mathematical methods to solve practical problems',
				],
			],
		},
	},
	'A-LEVELs': {
		title: ['Grade E', 'Grade D', 'Grade C', 'Grade B', 'Grade A'],
		English: {
			kp: [
				['Language, the Individual and Society', 'Language Varieties', 'Language Diversity and Change'],
				['Language, the Individual and Society', 'Language Varieties', 'Language Diversity and Change'],
				['Language, the Individual and Society', 'Language Varieties', 'Language Diversity and Change'],
				['Language, the Individual and Society', 'Language Varieties', 'Language Diversity and Change'],
				['Language, the Individual and Society', 'Language Varieties', 'Language Diversity and Change'],
			],
			lc: [
				[
					'Consolidate the basic',
					'Master language analysis methods and their applications',
					'Be able to write papers on language attitude',
				],
				[
					'Consolidate the basic',
					'Master language analysis methods and their applications',
					'Be able to write papers on language attitude',
				],
				[
					'Be familiar with the characteristics of English stylistic diversity',
					'Master the reading skills of articles in different styles',
					'Master basic language analysis methods',
					'Master the writing skills of oldt English',
				],
				[
					'Master the writing skills of various styles and old English',
					'Be able to discuss and speak in language',
					'Master the application skills of language survey',
				],
				[
					'Master the writing skills of various styles and old English',
					'Be able to discuss and speak in language',
					'Master the application skills of language survey',
				],
			],
		},
		Maths: {
			kp: [
				[
					'Quadratics',
					'Functions',
					'Coordinate geometry',
					'Circular measure',
					'Trigonometry',
					'Vectors',
					'Series',
					'Differentiation',
					'Integration',
				],
				[
					'Quadratics',
					'Functions',
					'Coordinate geometry',
					'Circular measure',
					'Trigonometry',
					'Vectors',
					'Series',
					'Differentiation',
					'Integration',
				],
				[
					'Quadratics',
					'Functions',
					'Coordinate geometry',
					'Circular measure',
					'Trigonometry',
					'Vectors',
					'Series',
					'Differentiation',
					'Integration',
				],
				[
					'Quadratics',
					'Functions',
					'Coordinate geometry',
					'Circular measure',
					'Trigonometry',
					'Vectors',
					'Series',
					'Differentiation',
					'Integration',
				],
				[
					'Quadratics',
					'Functions',
					'Coordinate geometry',
					'Circular measure',
					'Trigonometry',
					'Vectors',
					'Series',
					'Differentiation',
					'Integration',
				],
			],
			lc: [
				[
					'Consolidate the basic',
					'Master the necessary knowledge points of pure mathematics, mechanics, statistics and mathematical decision-making',
				],
				[
					'Consolidate the basic',
					'Master the required knowledge points of the five modules of basic mathematics',
					'Master the required key points of advanced mathematics S1, D1, FP1, S2, FP2 and M3',
				],
				['Capacity promotion', 'Master the required key points such as distinguish, functions and coordinate geometry'],
				[
					'Higher level of capacity',
					'Break through difficulties such as rectangular inequality, inverse function, trigonometry, etc',
					'Master the problem-solving skills of high-frequency error points',
				],
				[
					'Higher level of capacity',
					'Break through difficulties such as rectangular inequality, inverse function, trigonometry, etc',
					'Master the problem-solving skills of high-frequency error points',
				],
			],
		},
	},
};

const BODY_COLOR = ['#fefbea', ' #fef8ea', ' #fef4ea', ' #fef1ea', ' #feeeea', ' #feeaea'];

const cx = classNames.bind(styles);

function Subjects(props: Record<string, any>) {
	const [level, setLevel] = useState('SATs');
	const [subject, setSubject] = useState('English');

	return (
		<PageContainer>
			<div className={cx('layout')}>
				<div className={cx('clear-overflow')}>
					<div className={cx('bg')}>
						<div className={cx('red-circular')} />
						<div className={cx('green-circular')} />
						<div className={cx('yellow-circular')} />
					</div>
				</div>

				<h1>ONLINE TUTORING-SATs,GCSE,A-LEVELs</h1>

				<div className={cx('tabs')}>
					{Object.keys(TABLE_DATA).map((val) => (
						<button key={val} className={cx({ active: level === val })} onClick={() => setLevel(val)}>
							{val}
						</button>
					))}
				</div>

				<div className={cx('subject-btns')}>
					<button className={cx({ active: subject === 'English' })} onClick={() => setSubject('English')}>
						English
					</button>
					<button className={cx({ active: subject === 'Maths' })} onClick={() => setSubject('Maths')}>
						Maths
					</button>
				</div>

				<div className={cx('table')}>
					<div className={cx('t-head')} style={{ gridTemplateColumns: `repeat(${TABLE_DATA[level].title?.length + 1}, 1fr)` }}>
						<div />
						{TABLE_DATA[level].title?.map((val: string) => (
							<div key={val}>{val}</div>
						))}
					</div>
					<div className={cx('t-body')} style={{ gridTemplateColumns: `repeat(${TABLE_DATA[level].title?.length + 1}, 1fr)` }}>
						<div className={cx('body-left')}>Knowledge Points</div>
						{TABLE_DATA[level][subject].kp.map((ar: Array<string>, i: number) => (
							<div key={i} style={{ background: BODY_COLOR[i] }}>
								{ar.map((v, index) => (
									<p key={index}>
										{index + 1}. {v}
									</p>
								))}
							</div>
						))}

						<div className={cx('body-left')}>Level Of Capability</div>
						{TABLE_DATA[level][subject].lc.map((ar: Array<string>, i: number) => (
							<div key={i} style={{ background: BODY_COLOR[i] }}>
								{ar.map((v, index) => (
									<p key={index}>
										{index + 1}. {v}
									</p>
								))}
							</div>
						))}
					</div>
				</div>

				<button className={cx('arrange')} onClick={() => history.push('/')}>
					Arrange A Trial Lesson
				</button>
			</div>
		</PageContainer>
	);
}

export default Subjects;
